import {GetterTree, MutationTree, ActionTree} from 'vuex'
import {ModalsState} from '@/store/types'

type ModalsGetter = GetterTree<ModalsState, any>
type ModalsMutation = MutationTree<ModalsState>
type ModalsAction = ActionTree<ModalsState, any>

const state: ModalsState = {
  showTaskDateTimeModal: false,
  showServiceNewItemModal: false,
  showServiceEditItemModal: false,
  showSignatureModal: false,
  showCompleteSurveyConfirmationModal: false,
  showStartSurveyConfirmationModal: false,
}


const getters: ModalsGetter = {
  showTaskDateTimeModal: (state) => state.showTaskDateTimeModal,
  showServiceNewItemModal: (state) => state.showServiceNewItemModal,
  showServiceEditItemModal: (state) => state.showServiceEditItemModal,
  showSignatureModal: (state) => state.showSignatureModal,
  showCompleteSurveyConfirmationModal: (state) => state.showCompleteSurveyConfirmationModal,
  showStartSurveyConfirmationModal: (state) => state.showStartSurveyConfirmationModal,
}

const mutations: ModalsMutation = {
  setTaskDateTimeModal: (state, payload) => {
    state.showTaskDateTimeModal = payload
  },
  setServiceNewItemModal: (state, payload) => {
    state.showServiceNewItemModal = payload
  },
  setServiceEditItemModal: (state, payload) => {
    state.showServiceEditItemModal = payload
  },
  setSignatureModal: (state, payload) => {
    state.showSignatureModal = payload
  },
  setCompleteSurveyConfirmationModal: (state, payload) => {
    state.showCompleteSurveyConfirmationModal = payload
  },
  setStartSurveyConfirmationModal: (state, payload) => {
    state.showStartSurveyConfirmationModal = payload
  },
}

const actions: ModalsAction = {

}

export default {
  state,
  getters,
  mutations,
  actions,
}
